import { Table } from "react-bootstrap";
import Laoder from "../../../components/loading/Loader";
import useFilterParams from "../../../hooks/useFilterParams";
import jalaliTime from "../../../functions/jalaliTime";

function DigikalaCoworkerCreditTable({ items, count, isFetching }) {
  const filters = useFilterParams();

  return (
    <section className="pt-4">
      <p className="mb-0 px-1 fw-bold text-success">
        <span>تعداد: </span>
        <span>{count.toLocaleString()}</span>
      </p>
      <div className="w-100 px-1 overflow-x-auto">
        <Table striped bordered className="text-center">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره سفارش</th>
              <th>مبلغ</th>
              <th>اعتبار</th>
              <th>واریز/برداشت</th>
              <th>توضیحات</th>
              <th>کد رهگیری</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {isFetching && (
              <tr>
                <td colSpan="8">
                  <Laoder />
                </td>
              </tr>
            )}

            {isFetching === false &&
              items.map((item, idx) => (
                <tr key={item.id}>
                  <td>
                    {idx +
                      1 +
                      (filters.getParam("page") - 1) *
                        filters.getParam("items")}
                  </td>
                  <td>{item.numberParcel}</td>
                  <td>{item.isDeposit ? "واریز" : "برداشت"}</td>
                  <td>{item.amount.toLocaleString()}</td>
                  <td>{item.credit.toLocaleString()}</td>
                  <td>{item.description}</td>
                  <td>{item.trackingCode}</td>
                  <td>{jalaliTime(item.created_at).full}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </section>
  );
}
export default DigikalaCoworkerCreditTable;
